import { Link, useLocation } from 'react-router-dom';
import { Compass, User, Sparkles, Bookmark, UserCircle } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const tabs = [
  { icon: Compass, label: 'Discover', to: '/' },
  { icon: User, label: 'For You', to: '/for-you' },
  { icon: Sparkles, label: 'I Feel', to: '/feel' },
  { icon: Bookmark, label: 'Lists', to: '/lists' },
  { icon: UserCircle, label: 'Profile', to: '/profile' },
];

export function MobileTabBar() {
  const location = useLocation();
  const { user, profile } = useAuth();

  // Determine the profile URL
  const profileUrl = profile?.username ? `/u/${profile.username}` : '/auth/callback';

  // Get list URL (first default watchlist if available)
  const listsUrl = user ? '/for-you' : '/auth/callback'; // Redirect to For You which shows library

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-[#0F1419]/95 backdrop-blur-sm border-t border-white/[0.06] flex justify-around py-2 md:hidden z-50 safe-area-inset-bottom">
      {tabs.map(({ icon: Icon, label, to }) => {
        // Handle dynamic URLs
        let href = to;
        if (to === '/lists') href = listsUrl;
        if (to === '/profile') href = profileUrl;

        const isActive = location.pathname === href ||
          (to === '/profile' && location.pathname.startsWith('/u/')) ||
          (to === '/lists' && location.pathname.startsWith('/list/'));

        return (
          <Link
            key={to}
            to={href}
            className={`flex flex-col items-center gap-1 px-3 py-1 transition-colors active:scale-95 ${
              isActive ? 'text-teal-400' : 'text-slate-500'
            }`}
          >
            <Icon className="w-5 h-5" />
            <span className="text-[10px]">{label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
